/**
 * 权限管理工具函数
 * 用于判断用户是否有特定操作的权限
 */

/**
 * 权限类型定义
 */
export type PermissionType = 'employee' | 'admin' | 'materialAdmin'

/**
 * 检查是否有物料管理权限（车辆和配件的增删改）
 * 只有 admin 和 materialAdmin 有权限
 * @param roleCode 用户角色代码
 * @returns 是否有权限
 */
export function hasMaterialPermission(roleCode: string | undefined | null): boolean {
    if (!roleCode) return false
    return roleCode === 'admin' || roleCode === 'materialAdmin'
}

/**
 * 检查是否有管理员权限
 * 只有 admin 有权限
 * @param roleCode 用户角色代码
 * @returns 是否有权限
 */
export function hasAdminPermission(roleCode: string | undefined | null): boolean {
    if (!roleCode) return false
    return roleCode === 'admin'
}

/**
 * 检查是否有车辆管理权限（新增、编辑、删除）
 * @param roleCode 用户角色代码
 * @returns 是否有权限
 */
export function hasVehicleManagePermission(roleCode: string | undefined | null): boolean {
    return hasMaterialPermission(roleCode)
}

/**
 * 检查是否有配件管理权限（新增、编辑、删除）
 * @param roleCode 用户角色代码
 * @returns 是否有权限
 */
export function hasPartsManagePermission(roleCode: string | undefined | null): boolean {
    return hasMaterialPermission(roleCode)
}

/**
 * 获取规范化的权限类型
 * 如果角色代码不识别，默认返回 'employee'
 * @param roleCode 用户角色代码
 * @returns 规范化的权限类型
 */
export function getNormalizedPermission(roleCode: string | undefined | null): PermissionType {
    if (roleCode === 'admin') return 'admin'
    if (roleCode === 'materialAdmin') return 'materialAdmin'
    return 'employee' // 默认权限
}
